import * as experiments from './experiments';
import { SHARE_TYPES } from './types';

export const STATSIG_EVENT_NAMES = {
    CHECKOUT_AFTER_ORDER_PLACEMENT_QUESTIONS_SUBMISSION:
        'Checkout - PreTickets - Success - Organizers Questions',
    CHECKOUT_ALL_CART_SUMMARY_CLICK: 'Checkout - All - Click - Cart Summary',
    CHECKOUT_ALL_SUCCESS_ABANDON_ORDER:
        'Checkout - All - Sucsess - Abandon Order',

    CHECKOUT_STEP_ORDER_SUCCESS:
        'Checkout - Checkout Step - Success - Place Order',
    CHECKOUT_STEP_PAID_SUCCESS:
        'Checkout - Checkout Step - Success - Paid Event - Place Order',
    CHECKOUT_STEP_PAGE_VIEW: 'Checkout - Checkout Step - View - Page',
    CHECKOUT_STEP_PLACE_ORDER_CLICK:
        'Checkout - Checkout Step - Click - Place Order',
    CHECKOUT_STEP_ORDER_CONFIRMATION_CLICK_EVENTS:
        'Checkout - Order Confirmation Step - Click - Related Event(s)',
    CHECKOUT_STEP_ORDER_CONFIRMATION_CLICK_EVENT_LIKES:
        'Checkout - Order Confirmation Step - Click - Related Event Like',
    CHECKOUT_STEP_ORDER_CONFIRMATION_CLICK_EVENT_SHARES:
        'Checkout - Order Confirmation Step - Click - Related Event Share',
    CHECKOUT_STEP_ORDER_CONFIRMATION_CLICK_FOLLOW_BUTTON:
        'Checkout - Order Confirmation Step - Click - Follow Button',
    CHECKOUT_STEP_ORDER_CONFIRMATION_SHARE_EVENTS: {
        [SHARE_TYPES.EMAIL]:
            'Checkout - Order Confirmation Step - Click - Email Share',
        [SHARE_TYPES.FACEBOOK]:
            'Checkout - Order Confirmation Step - Click - Facebook Share',
        [SHARE_TYPES.FACEBOOK_MESSENGER]:
            'Checkout - Order Confirmation Step - Click - Facebook Messenger Share',
        [SHARE_TYPES.TWITTER]:
            'Checkout - Order Confirmation Step - Click - Twitter Share',
    },
    CHECKOUT_STEP_ORDER_CONFIRMATION_VIEW_PAGE:
        'Checkout - Order Confirmation Step - View - Page',
    CHECKOUT_STEP_ORDER_CONFIRMATION_VIEW_TICKETS:
        'Checkout - Order Confirmation Step - Click - View Tickets',
    CHECKOUT_STEP_ORDER_CONFIRMATION_CLICK_REFERRAL_CTA:
        'Checkout - Order Confirmation Step - Click - Referral CTA',
    CHECKOUT_STEP_SUCCESS_ORGANIZER_QUESTIONS_RATIO:
        'Checkout - Order Form - Success - Organizers Questions Submitted',
    CHECKOUT_STEP_ORGANIZER_QUESTIONS_VIEW:
        'Checkout - Organizer Additional Questions - View - Page',
    CHECKOUT_STEP_ORGANIZER_QUESTIONS_CLICK:
        'Checkout - Organizer Additional Questions - Click - Submit CTA',

    CHECKOUT_STEP_QUESTIONS_MODAL_VIEW:
        'Checkout - Checkout Step - View - Questions Modal',
    CHECKOUT_STEP_QUESTIONS_MODAL_CLICK:
        'Checkout - Checkout Step - Click - Questions Modal CTA',
    CHECKOUT_STEP_QUESTIONS_MODAL_CLOSE:
        'Checkout - Checkout Step - Click - Questions Modal Close',
    TOS_NOTIFICATION_DISPLAYED: 'Checkout - Checkout Step - View - ToS error',
    CHECKOUT_STEP_BACK_CLOSED_AFTER_TOS:
        'Checkout - Checkout Step - Click - Abandon Order ToS',

    TICKET_STEP_PAGE_VIEW: 'Checkout - Ticket Selection Step - View - Page',
    TICKET_STEP_CONTINUE_TO_PAYMENT_CLICK:
        'Checkout - Ticket Selection Step - Click - Continue to payment',
    TICKET_STEP_VALIDATION_ERROR_VIEW:
        'Checkout - Ticket Selection Step - View - Validation Error',
    TICKET_SELECTION_STEP_REMOVE_PROMO_CODE:
        'Checkout - Ticket Selection Step - Click - Remove Promo Code',
    TICKET_SELECTION_STEP_APPLY_PROMO_CODE:
        'Checkout - Ticket Selection Step - Click - Apply Promo Code',
    TICKET_SELECTION_STEP_ERROR_PROMO_CODE:
        'Checkout - Ticket Selection Step - View - Promo Code Error',
    TICKET_SELECTION_COMPACT_STEP_MORE_INFO_CLICK:
        'Listing - Conversion Bar - More info Button - Change - Compact Ticket Selection',
    LOGIN_STEP_PAGE_VIEW: 'Checkout - Login Step - View - Page',
    LOGIN_STEP_SUCCESS_LOGIN: 'Checkout - Login Step - Success - Button Login',

    APPLE_PAY_VIEW_BUTTON: 'Checkout - ApplePay - View - Button',
};

// This object is used by Cypress to force control in all experiments by default.
export const STATSIG_PARAMETERS_FOR_ALL_EXPERIMENTS_IN_CONTROL =
    Object.fromEntries(
        Object.entries(experiments).flatMap(
            ([key, { param, defaultValue }]) => [
                [key, defaultValue],
                [param, defaultValue],
            ],
        ),
    );

export * from './experiments';
export * from './types';
